export const EQUIPMENT_TYPES = [
  {
    id: 'na',
    name: 'N/A',
  },
  {
    id: 'dehumidifier',
    name: 'Dehumidifier',
  },
];
